// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Oswald:wght@300;400;500&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Red+Hat+Display:wght@400;500;600;700&family=Roboto:wght@400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  background-color: #ffffff;
}

.container-nav {
  width: 100%;
  position: fixed;
}

.navbar {
  width: 100%;
  height: 90px;
  background-color: #fff;
  /* position: fixed; */
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
}

.kiri-nav {
  height: 100%;
  width: -moz-fit-content;
  width: fit-content;
  /* background-color: blue; */
  margin: 0px 0px 0px 30px;
  display: flex;
  justify-content: space-between;
}

.logo {
  width: 50px;
  height: 50px;
  margin: 12px 3px 0px 0px;
}

.logo-title {
  font-family: "Red Hat Display", sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 22px 12px;
}

.kanan-nav {
  height: 100%;
  width: -moz-fit-content;
  width: fit-content;
  /* background-color: green; */
  margin: 0px 30px 0px 0px;
  display: flex;
  justify-content: space-between;
}

.nav-1 {
  font-family: "Red Hat Display", sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 20px 25px 0px 25px;
}

.nav-2 {
  font-family: "Red Hat Display", sans-serif;
  font-size: 20px;
  font-weight: 500;
  margin: 20px 25px 0px 25px;
}

.profile-picture {
  width: 46px;
  height: 46px;
  background-color: #49bc93;
  border-radius: 100px;
  margin: 13px 0px 0px 20px;
}

.pp-initial {
  text-align: center;
  font-family: "Red Hat Display", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 10px 0px 0px 0px;
}

.search-header {
  margin: 0px 2%;
  padding-top: 100px;
  display: flex;
  justify-content: space-between;
  width: 96%;
  height: -moz-fit-content;
  height: fit-content;
  /* background-color: red; */
  position: fixed;
}

.search-header .kiri {
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  justify-content: space-between;
}

.search {
  width: 100%;
  position: relative;
  display: flex;
}

.searchTerm {
  width: 362px;
  border: 4px solid #00b4cc;
  padding: 5px 7px;
  height: 36px;
  border-radius: 5px;
  outline: none;
  color: #000;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
}

.searchTerm2 {
  width: 250px;
  margin-left: 10px;
  border: 4px solid #00b4cc;
  padding: 5px 7px;
  height: 36px;
  border-radius: 5px;
  outline: none;
  color: #000;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
}

.searchTerm2:focus {
  color: #000;
}

.searchTerm:focus {
  color: #000;
}

.searchTerm::placeholder {
  color: #A09696;
}

.searchTerm2::placeholder {
  color: #A09696;
}

.searchButton {
  background-color: #ff000000;
  border: 0px solid black;
  margin-left: -30px;
  width: 30px;
}

.search-wrap {
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.search-header .kanan {
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  justify-content: space-between;
}

.spacing-one {
  width: 10px;
  height: 10px;
}

.button-wrap {
  background-color: #069DAE;
  padding: 6px 18px;
  border-radius: 4px;
  margin-top: 2px;
  cursor: pointer;
}

.button-wrap a {
  color: #FFF;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Roboto', sans-serif;
  text-decoration: none;
}


/* .user-management {

    background-color: #e9f2f7e3;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
  
  .user-management .div {
    background-color: #e9f2f7e3;
    border: 1px none;
    height: 1080px;
    overflow: hidden;
    position: relative;
    width: 100%;
  }
  
  .user-management .navbar {
    height: 70px;
    left: 32px;
    position: absolute;
    top: 165px;
    width: 100%;
  }
  
  .user-management .header-tabel {
    height: 70px;
    left: 0;
    position: absolute;
    top: 0;
    width: 1857px;
  }
  
  .user-management .rectangle {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 0;
    position: absolute;
    top: 0;
    width: 131px;
  }
  
  .user-management .rectangle-2 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 136px;
    position: absolute;
    top: 0;
    width: 226px;
  }
  
  .user-management .rectangle-3 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1675px;
    position: absolute;
    top: 0;
    width: 182px;
  }
  
  .user-management .rectangle-4 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1021px;
    position: absolute;
    top: 0;
    width: 321px;
  }
  
  .user-management .rectangle-5 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1347px;
    position: absolute;
    top: 0;
    width: 323px;
  }
  
  .user-management .rectangle-6 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 367px;
    position: absolute;
    top: 0;
    width: 321px;
  }
  
  .user-management .rectangle-7 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 694px;
    position: absolute;
    top: 0;
    width: 321px;
  }
  
  .user-management .text-wrapper {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 793px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .user-management .text-wrapper-2 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 48px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .user-management .text-wrapper-3 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 203px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .user-management .text-wrapper-4 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 1436px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .user-management .text-wrapper-5 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 1724px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .user-management .text-wrapper-6 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 496px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .user-management .text-wrapper-7 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 1093px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .user-management .overlap {
    background-color: #ffffff;
    border: 1px solid;
    border-color: #d9d9d9;
    height: 102px;
    left: -1px;
    position: absolute;
    top: -1px;
    width: 1922px;
  }
  
  .user-management .header-DATA {
    color: #000000;
    font-family: "Red Hat Display-Bold", Helvetica;
    font-size: 24px;
    font-weight: 700;
    left: 110px;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 33px;
  }
  
  .user-management .action-project {
    color: #000000;
    font-family: "Montserrat-SemiBold", Helvetica;
    font-size: 24px;
    font-weight: 600;
    left: 1329px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    top: 35px;
  }
  
  .user-management .action-dashboard {
    color: #000000;
    font-family: "Montserrat-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 1650px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    top: 35px;
  }
  
  .user-management .profile-icon {
    background-color: #49bc92;
    border-radius: 25px;
    height: 50px;
    left: 1840px;
    position: absolute;
    top: 25px;
    width: 50px;
  }
  
  .user-management .s {
    height: 18px;
    left: 19px;
    position: absolute;
    top: 16px;
    width: 13px;
  }
  
  .user-management .logo-SIVINA {
    background-image: url(../assets/images/bg/logo.png);
    background-size: 100% 100%;
    height: 60px;
    left: 29px;
    position: absolute;
    top: 20px;
    width: 60px;
  }
  
  .user-management .caption-menampilkan {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 813px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 1030px;
    white-space: nowrap;
  }
  
  .user-management .page {
    height: 35px;
    left: 1640px;
    position: absolute;
    top: 1027px;
    width: 257px;
  }
  
  .user-management .text-wrapper-8 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 45px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .user-management .text-wrapper-9 {
    color: #000000;
    font-family: "Roboto-SemiBold", Helvetica;
    font-size: 24px;
    font-weight: 600;
    left: 0;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .user-management .button-next {
    height: 35px;
    left: 169px;
    position: absolute;
    top: 0;
    width: 37px;
  }
  
  .user-management .overlap-group {
    background-color: #069dae;
    border-radius: 5px;
    height: 35px;
    position: relative;
    width: 35px;
  }
  
  .user-management .text-wrapper-10 {
    color: #ffffff;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .user-management .text-wrapper-11 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 87px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .user-management .text-wrapper-12 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 135px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 3px;
    white-space: nowrap;
  }
  
  .user-management .button-end {
    height: 35px;
    left: 214px;
    position: absolute;
    top: 0;
    width: 37px;
  }
  
  .user-management .text-wrapper-13 {
    color: #ffffff;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 2px;
    white-space: nowrap;
  }
  
  .user-management .vector-stroke {
    height: 6px;
    left: 13px;
    position: absolute;
    top: 19px;
    width: 10px;
  }
  
  .user-management .button-add-new {
    height: 40px;
    left: 1670px;
    position: absolute;
    top: 115px;
    width: 222px;
  }
  
  .user-management .div-wrapper {
    background-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 220px;
  }
  
  .user-management .text-wrapper-14 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 47px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 8px;
    white-space: nowrap;
  }
  
  .user-management .overlap-wrapper {
    height: 40px;
    left: 1445px;
    position: absolute;
    top: 115px;
    width: 222px;
  }
  
  .user-management .text-wrapper-15 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 56px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 8px;
    white-space: nowrap;
  }
  
  .user-management .action-search {
    height: 40px;
    left: 32px;
    position: absolute;
    top: 115px;
    width: 464px;
  }
  
  .user-management .overlap-2 {
    background-color: #ffffff;
    border: 3px solid;
    border-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 462px;
  }
  
  .user-management .text-wrapper-16 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 5px;
    white-space: nowrap;
  }
  
  .user-management .union {
    height: 17px;
    left: 428px;
    position: absolute;
    top: 8px;
    width: 17px;
  }
  
  .user-management .baris-isi {
    height: 765px;
    left: 30px;
    overflow: hidden;
    overflow-y: scroll;
    position: absolute;
    top: 250px;
    width: 1857px;
  }
  
  .user-management .overlap-3 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 0;
    width: 131px;
  }
  
  .user-management .text-wrapper-17 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 59px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .user-management .overlap-4 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 0;
    width: 225px;
  }
  
  .user-management .text-wrapper-18 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 63px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .user-management .overlap-5 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 0;
    width: 324px;
  }
  
  .user-management .text-wrapper-19 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 83px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    width: 158px;
  }
  
  .user-management .overlap-6 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 0;
    width: 324px;
  }
  
  .user-management .text-wrapper-20 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 107px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .user-management .rectangle-8 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 0;
    width: 180px;
  }
  
  .user-management .overlap-7 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 0;
    width: 321px;
  }
  
  .user-management .text-wrapper-21 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 65px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .user-management .overlap-8 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 0;
    width: 323px;
  }
  
  .user-management .overlap-9 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 55px;
    width: 131px;
  }
  
  .user-management .overlap-10 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 55px;
    width: 225px;
  }
  
  .user-management .overlap-11 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 55px;
    width: 324px;
  }
  
  .user-management .text-wrapper-22 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 85px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 9px;
    width: 153px;
  }
  
  .user-management .overlap-12 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 55px;
    width: 324px;
  }
  
  .user-management .text-wrapper-23 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 77px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .user-management .rectangle-9 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 55px;
    width: 180px;
  }
  
  .user-management .overlap-13 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 55px;
    width: 321px;
  }
  
  .user-management .text-wrapper-24 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 65px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 9px;
    white-space: nowrap;
  }
  
  .user-management .overlap-14 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 55px;
    width: 323px;
  }
  
  .user-management .text-wrapper-25 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 66px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 9px;
    width: 191px;
  }
  
  .user-management .overlap-15 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 110px;
    width: 131px;
  }
  
  .user-management .overlap-16 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 110px;
    width: 225px;
  }
  
  .user-management .overlap-17 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 110px;
    width: 324px;
  }
  
  .user-management .text-wrapper-26 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 87px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    width: 150px;
  }
  
  .user-management .overlap-18 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 110px;
    width: 324px;
  }
  
  .user-management .rectangle-10 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 110px;
    width: 180px;
  }
  
  .user-management .overlap-19 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 110px;
    width: 321px;
  }
  
  .user-management .overlap-20 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 110px;
    width: 323px;
  }
  
  .user-management .text-wrapper-27 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 81px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    width: 162px;
  }
  
  .user-management .overlap-21 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 165px;
    width: 131px;
  }
  
  .user-management .overlap-22 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 220px;
    width: 131px;
  }
  
  .user-management .rectangle-11 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 275px;
    width: 131px;
  }
  
  .user-management .rectangle-12 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 330px;
    width: 131px;
  }
  
  .user-management .rectangle-13 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 385px;
    width: 131px;
  }
  
  .user-management .rectangle-14 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 440px;
    width: 131px;
  }
  
  .user-management .rectangle-15 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 495px;
    width: 131px;
  }
  
  .user-management .rectangle-16 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 550px;
    width: 131px;
  }
  
  .user-management .rectangle-17 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 605px;
    width: 131px;
  }
  
  .user-management .rectangle-18 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 660px;
    width: 131px;
  }
  
  .user-management .rectangle-19 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 715px;
    width: 131px;
  }
  
  .user-management .rectangle-20 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 770px;
    width: 131px;
  }
  
  .user-management .overlap-23 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 165px;
    width: 225px;
  }
  
  .user-management .overlap-24 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 220px;
    width: 225px;
  }
  
  .user-management .rectangle-21 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 275px;
    width: 225px;
  }
  
  .user-management .rectangle-22 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 330px;
    width: 225px;
  }
  
  .user-management .rectangle-23 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 385px;
    width: 225px;
  }
  
  .user-management .rectangle-24 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 440px;
    width: 225px;
  }
  
  .user-management .rectangle-25 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 495px;
    width: 225px;
  }
  
  .user-management .rectangle-26 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 550px;
    width: 225px;
  }
  
  .user-management .rectangle-27 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 605px;
    width: 225px;
  }
  
  .user-management .rectangle-28 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 660px;
    width: 225px;
  }
  
  .user-management .rectangle-29 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 715px;
    width: 225px;
  }
  
  .user-management .rectangle-30 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 770px;
    width: 225px;
  }
  
  .user-management .overlap-25 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 165px;
    width: 324px;
  }
  
  .user-management .text-wrapper-28 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 78px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    width: 167px;
  }
  
  .user-management .overlap-26 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 165px;
    width: 324px;
  }
  
  .user-management .text-wrapper-29 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 74px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .user-management .overlap-27 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 220px;
    width: 324px;
  }
  
  .user-management .text-wrapper-30 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 57px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    width: 209px;
  }
  
  .user-management .overlap-28 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 220px;
    width: 324px;
  }
  
  .user-management .rectangle-31 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 275px;
    width: 324px;
  }
  
  .user-management .rectangle-32 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 275px;
    width: 324px;
  }
  
  .user-management .rectangle-33 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 330px;
    width: 324px;
  }
  
  .user-management .rectangle-34 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 330px;
    width: 324px;
  }
  
  .user-management .rectangle-35 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 385px;
    width: 324px;
  }
  
  .user-management .rectangle-36 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 385px;
    width: 324px;
  }
  
  .user-management .rectangle-37 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 440px;
    width: 324px;
  }
  
  .user-management .rectangle-38 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 440px;
    width: 324px;
  }
  
  .user-management .rectangle-39 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 495px;
    width: 324px;
  }
  
  .user-management .rectangle-40 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 495px;
    width: 324px;
  }
  
  .user-management .rectangle-41 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 550px;
    width: 324px;
  }
  
  .user-management .rectangle-42 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 550px;
    width: 324px;
  }
  
  .user-management .rectangle-43 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 605px;
    width: 324px;
  }
  
  .user-management .rectangle-44 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 605px;
    width: 324px;
  }
  
  .user-management .rectangle-45 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 660px;
    width: 324px;
  }
  
  .user-management .rectangle-46 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 660px;
    width: 324px;
  }
  
  .user-management .rectangle-47 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 715px;
    width: 324px;
  }
  
  .user-management .rectangle-48 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 715px;
    width: 324px;
  }
  
  .user-management .rectangle-49 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 770px;
    width: 324px;
  }
  
  .user-management .rectangle-50 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 770px;
    width: 324px;
  }
  
  .user-management .rectangle-51 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 165px;
    width: 180px;
  }
  
  .user-management .overlap-29 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 165px;
    width: 321px;
  }
  
  .user-management .rectangle-52 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 220px;
    width: 180px;
  }
  
  .user-management .overlap-30 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 220px;
    width: 321px;
  }
  
  .user-management .rectangle-53 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 275px;
    width: 180px;
  }
  
  .user-management .rectangle-54 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 275px;
    width: 321px;
  }
  
  .user-management .rectangle-55 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 330px;
    width: 180px;
  }
  
  .user-management .rectangle-56 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 330px;
    width: 321px;
  }
  
  .user-management .rectangle-57 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 385px;
    width: 180px;
  }
  
  .user-management .rectangle-58 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 385px;
    width: 321px;
  }
  
  .user-management .rectangle-59 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 440px;
    width: 180px;
  }
  
  .user-management .rectangle-60 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 440px;
    width: 321px;
  }
  
  .user-management .rectangle-61 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 495px;
    width: 180px;
  }
  
  .user-management .rectangle-62 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 495px;
    width: 321px;
  }
  
  .user-management .rectangle-63 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 550px;
    width: 180px;
  }
  
  .user-management .rectangle-64 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 550px;
    width: 321px;
  }
  
  .user-management .rectangle-65 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 605px;
    width: 180px;
  }
  
  .user-management .rectangle-66 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 605px;
    width: 321px;
  }
  
  .user-management .rectangle-67 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 660px;
    width: 180px;
  }
  
  .user-management .rectangle-68 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 660px;
    width: 321px;
  }
  
  .user-management .rectangle-69 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 715px;
    width: 180px;
  }
  
  .user-management .rectangle-70 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 715px;
    width: 321px;
  }
  
  .user-management .rectangle-71 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 770px;
    width: 180px;
  }
  
  .user-management .rectangle-72 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 770px;
    width: 321px;
  }
  
  .user-management .overlap-31 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 165px;
    width: 323px;
  }
  
  .user-management .text-wrapper-31 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 86px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    width: 152px;
  }
  
  .user-management .overlap-32 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 220px;
    width: 323px;
  }
  
  .user-management .text-wrapper-32 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 84px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    width: 156px;
  }
  
  .user-management .rectangle-73 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 275px;
    width: 323px;
  }
  
  .user-management .rectangle-74 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 330px;
    width: 323px;
  }
  
  .user-management .rectangle-75 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 385px;
    width: 323px;
  }
  
  .user-management .rectangle-76 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 440px;
    width: 323px;
  }
  
  .user-management .rectangle-77 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 495px;
    width: 323px;
  }
  
  .user-management .rectangle-78 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 550px;
    width: 323px;
  }
  
  .user-management .rectangle-79 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 605px;
    width: 323px;
  }
  
  .user-management .rectangle-80 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 660px;
    width: 323px;
  }
  
  .user-management .rectangle-81 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 715px;
    width: 323px;
  }
  
  .user-management .rectangle-82 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 770px;
    width: 323px;
  }
  
  .user-management .rectangle-83 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 825px;
    width: 131px;
  }
  
  .user-management .rectangle-84 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 825px;
    width: 225px;
  }
  
  .user-management .rectangle-85 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 825px;
    width: 324px;
  }
  
  .user-management .rectangle-86 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 825px;
    width: 324px;
  }
  
  .user-management .rectangle-87 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 825px;
    width: 180px;
  }
  
  .user-management .rectangle-88 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 825px;
    width: 321px;
  }
  
  .user-management .rectangle-89 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 825px;
    width: 323px;
  }
  
  .user-management .rectangle-90 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 880px;
    width: 131px;
  }
  
  .user-management .rectangle-91 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 935px;
    width: 131px;
  }
  
  .user-management .rectangle-92 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 990px;
    width: 131px;
  }
  
  .user-management .rectangle-93 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1045px;
    width: 131px;
  }
  
  .user-management .rectangle-94 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1100px;
    width: 131px;
  }
  
  .user-management .rectangle-95 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1155px;
    width: 131px;
  }
  
  .user-management .rectangle-96 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1210px;
    width: 131px;
  }
  
  .user-management .rectangle-97 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1265px;
    width: 131px;
  }
  
  .user-management .rectangle-98 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1320px;
    width: 131px;
  }
  
  .user-management .rectangle-99 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 880px;
    width: 225px;
  }
  
  .user-management .rectangle-100 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 935px;
    width: 225px;
  }
  
  .user-management .rectangle-101 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 990px;
    width: 225px;
  }
  
  .user-management .rectangle-102 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1045px;
    width: 225px;
  }
  
  .user-management .rectangle-103 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1100px;
    width: 225px;
  }
  
  .user-management .rectangle-104 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1155px;
    width: 225px;
  }
  
  .user-management .rectangle-105 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1210px;
    width: 225px;
  }
  
  .user-management .rectangle-106 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1265px;
    width: 225px;
  }
  
  .user-management .rectangle-107 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1320px;
    width: 225px;
  }
  
  .user-management .rectangle-108 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 880px;
    width: 324px;
  }
  
  .user-management .rectangle-109 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 880px;
    width: 324px;
  }
  
  .user-management .rectangle-110 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 935px;
    width: 324px;
  }
  
  .user-management .rectangle-111 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 935px;
    width: 324px;
  }
  
  .user-management .rectangle-112 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 990px;
    width: 324px;
  }
  
  .user-management .rectangle-113 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 990px;
    width: 324px;
  }
  
  .user-management .rectangle-114 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 1045px;
    width: 324px;
  }
  
  .user-management .rectangle-115 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 1045px;
    width: 324px;
  }
  
  .user-management .rectangle-116 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 1100px;
    width: 324px;
  }
  
  .user-management .rectangle-117 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 1100px;
    width: 324px;
  }
  
  .user-management .rectangle-118 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 1155px;
    width: 324px;
  }
  
  .user-management .rectangle-119 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 1155px;
    width: 324px;
  }
  
  .user-management .rectangle-120 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 1210px;
    width: 324px;
  }
  
  .user-management .rectangle-121 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 1210px;
    width: 324px;
  }
  
  .user-management .rectangle-122 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 1265px;
    width: 324px;
  }
  
  .user-management .rectangle-123 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 1265px;
    width: 324px;
  }
  
  .user-management .rectangle-124 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 695px;
    position: absolute;
    top: 1320px;
    width: 324px;
  }
  
  .user-management .rectangle-125 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 366px;
    position: absolute;
    top: 1320px;
    width: 324px;
  }
  
  .user-management .rectangle-126 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 880px;
    width: 180px;
  }
  
  .user-management .rectangle-127 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 880px;
    width: 321px;
  }
  
  .user-management .rectangle-128 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 935px;
    width: 180px;
  }
  
  .user-management .rectangle-129 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 935px;
    width: 321px;
  }
  
  .user-management .rectangle-130 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 990px;
    width: 180px;
  }
  
  .user-management .rectangle-131 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 990px;
    width: 321px;
  }
  
  .user-management .rectangle-132 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1045px;
    width: 180px;
  }
  
  .user-management .rectangle-133 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1045px;
    width: 321px;
  }
  
  .user-management .rectangle-134 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1100px;
    width: 180px;
  }
  
  .user-management .rectangle-135 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1100px;
    width: 321px;
  }
  
  .user-management .rectangle-136 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1155px;
    width: 180px;
  }
  
  .user-management .rectangle-137 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1155px;
    width: 321px;
  }
  
  .user-management .rectangle-138 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1210px;
    width: 180px;
  }
  
  .user-management .rectangle-139 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1210px;
    width: 321px;
  }
  
  .user-management .rectangle-140 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1265px;
    width: 180px;
  }
  
  .user-management .rectangle-141 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1265px;
    width: 321px;
  }
  
  .user-management .rectangle-142 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1320px;
    width: 180px;
  }
  
  .user-management .rectangle-143 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1320px;
    width: 321px;
  }
  
  .user-management .rectangle-144 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 880px;
    width: 323px;
  }
  
  .user-management .rectangle-145 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 935px;
    width: 323px;
  }
  
  .user-management .rectangle-146 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 990px;
    width: 323px;
  }
  
  .user-management .rectangle-147 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 1045px;
    width: 323px;
  }
  
  .user-management .rectangle-148 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 1100px;
    width: 323px;
  }
  
  .user-management .rectangle-149 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 1155px;
    width: 323px;
  }
  
  .user-management .rectangle-150 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 1210px;
    width: 323px;
  }
  
  .user-management .rectangle-151 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 1265px;
    width: 323px;
  }
  
  .user-management .rectangle-152 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1349px;
    position: absolute;
    top: 1320px;
    width: 323px;
  }
   */
`, "",{"version":3,"sources":["webpack://./src/style/user.css"],"names":[],"mappings":"AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAm7EI","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Oswald:wght@300;400;500&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Red+Hat+Display:wght@400;500;600;700&family=Roboto:wght@400;500;700&display=swap\");\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');\n\nhtml {\n  background-color: #ffffff;\n}\n\n.container-nav {\n  width: 100%;\n  position: fixed;\n}\n\n.navbar {\n  width: 100%;\n  height: 90px;\n  background-color: #fff;\n  /* position: fixed; */\n  /* background-color: red; */\n  display: flex;\n  justify-content: space-between;\n}\n\n.kiri-nav {\n  height: 100%;\n  width: fit-content;\n  /* background-color: blue; */\n  margin: 0px 0px 0px 30px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.logo {\n  width: 50px;\n  height: 50px;\n  margin: 12px 3px 0px 0px;\n}\n\n.logo-title {\n  font-family: \"Red Hat Display\", sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 22px 12px;\n}\n\n.kanan-nav {\n  height: 100%;\n  width: fit-content;\n  /* background-color: green; */\n  margin: 0px 30px 0px 0px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.nav-1 {\n  font-family: \"Red Hat Display\", sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 20px 25px 0px 25px;\n}\n\n.nav-2 {\n  font-family: \"Red Hat Display\", sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n  margin: 20px 25px 0px 25px;\n}\n\n.profile-picture {\n  width: 46px;\n  height: 46px;\n  background-color: #49bc93;\n  border-radius: 100px;\n  margin: 13px 0px 0px 20px;\n}\n\n.pp-initial {\n  text-align: center;\n  font-family: \"Red Hat Display\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n  margin: 10px 0px 0px 0px;\n}\n\n.search-header {\n  margin: 0px 2%;\n  padding-top: 100px;\n  display: flex;\n  justify-content: space-between;\n  width: 96%;\n  height: fit-content;\n  /* background-color: red; */\n  position: fixed;\n}\n\n.search-header .kiri {\n  width: fit-content;\n  height: fit-content;\n  display: flex;\n  justify-content: space-between;\n}\n\n.search {\n  width: 100%;\n  position: relative;\n  display: flex;\n}\n\n.searchTerm {\n  width: 362px;\n  border: 4px solid #00b4cc;\n  padding: 5px 7px;\n  height: 36px;\n  border-radius: 5px;\n  outline: none;\n  color: #000;\n  font-size: 14px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n}\n\n.searchTerm2 {\n  width: 250px;\n  margin-left: 10px;\n  border: 4px solid #00b4cc;\n  padding: 5px 7px;\n  height: 36px;\n  border-radius: 5px;\n  outline: none;\n  color: #000;\n  font-size: 14px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n}\n\n.searchTerm2:focus {\n  color: #000;\n}\n\n.searchTerm:focus {\n  color: #000;\n}\n\n.searchTerm::placeholder {\n  color: #A09696;\n}\n\n.searchTerm2::placeholder {\n  color: #A09696;\n}\n\n.searchButton {\n  background-color: #ff000000;\n  border: 0px solid black;\n  margin-left: -30px;\n  width: 30px;\n}\n\n.search-wrap {\n  width: fit-content;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.search-header .kanan {\n  width: fit-content;\n  height: fit-content;\n  display: flex;\n  justify-content: space-between;\n}\n\n.spacing-one {\n  width: 10px;\n  height: 10px;\n}\n\n.button-wrap {\n  background-color: #069DAE;\n  padding: 6px 18px;\n  border-radius: 4px;\n  margin-top: 2px;\n  cursor: pointer;\n}\n\n.button-wrap a {\n  color: #FFF;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Roboto', sans-serif;\n  text-decoration: none;\n}\n\n\n/* .user-management {\n\n    background-color: #e9f2f7e3;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .user-management .div {\n    background-color: #e9f2f7e3;\n    border: 1px none;\n    height: 1080px;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n  }\n  \n  .user-management .navbar {\n    height: 70px;\n    left: 32px;\n    position: absolute;\n    top: 165px;\n    width: 100%;\n  }\n  \n  .user-management .header-tabel {\n    height: 70px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 1857px;\n  }\n  \n  .user-management .rectangle {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-2 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 136px;\n    position: absolute;\n    top: 0;\n    width: 226px;\n  }\n  \n  .user-management .rectangle-3 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1675px;\n    position: absolute;\n    top: 0;\n    width: 182px;\n  }\n  \n  .user-management .rectangle-4 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1021px;\n    position: absolute;\n    top: 0;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-5 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1347px;\n    position: absolute;\n    top: 0;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-6 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 367px;\n    position: absolute;\n    top: 0;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-7 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 694px;\n    position: absolute;\n    top: 0;\n    width: 321px;\n  }\n  \n  .user-management .text-wrapper {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 793px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .user-management .text-wrapper-2 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 48px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .user-management .text-wrapper-3 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 203px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .user-management .text-wrapper-4 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 1436px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .user-management .text-wrapper-5 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 1724px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .user-management .text-wrapper-6 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 496px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .user-management .text-wrapper-7 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 1093px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .user-management .overlap {\n    background-color: #ffffff;\n    border: 1px solid;\n    border-color: #d9d9d9;\n    height: 102px;\n    left: -1px;\n    position: absolute;\n    top: -1px;\n    width: 1922px;\n  }\n  \n  .user-management .header-DATA {\n    color: #000000;\n    font-family: \"Red Hat Display-Bold\", Helvetica;\n    font-size: 24px;\n    font-weight: 700;\n    left: 110px;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 33px;\n  }\n  \n  .user-management .action-project {\n    color: #000000;\n    font-family: \"Montserrat-SemiBold\", Helvetica;\n    font-size: 24px;\n    font-weight: 600;\n    left: 1329px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    top: 35px;\n  }\n  \n  .user-management .action-dashboard {\n    color: #000000;\n    font-family: \"Montserrat-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 1650px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    top: 35px;\n  }\n  \n  .user-management .profile-icon {\n    background-color: #49bc92;\n    border-radius: 25px;\n    height: 50px;\n    left: 1840px;\n    position: absolute;\n    top: 25px;\n    width: 50px;\n  }\n  \n  .user-management .s {\n    height: 18px;\n    left: 19px;\n    position: absolute;\n    top: 16px;\n    width: 13px;\n  }\n  \n  .user-management .logo-SIVINA {\n    background-image: url(../assets/images/bg/logo.png);\n    background-size: 100% 100%;\n    height: 60px;\n    left: 29px;\n    position: absolute;\n    top: 20px;\n    width: 60px;\n  }\n  \n  .user-management .caption-menampilkan {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 813px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 1030px;\n    white-space: nowrap;\n  }\n  \n  .user-management .page {\n    height: 35px;\n    left: 1640px;\n    position: absolute;\n    top: 1027px;\n    width: 257px;\n  }\n  \n  .user-management .text-wrapper-8 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 45px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .user-management .text-wrapper-9 {\n    color: #000000;\n    font-family: \"Roboto-SemiBold\", Helvetica;\n    font-size: 24px;\n    font-weight: 600;\n    left: 0;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .user-management .button-next {\n    height: 35px;\n    left: 169px;\n    position: absolute;\n    top: 0;\n    width: 37px;\n  }\n  \n  .user-management .overlap-group {\n    background-color: #069dae;\n    border-radius: 5px;\n    height: 35px;\n    position: relative;\n    width: 35px;\n  }\n  \n  .user-management .text-wrapper-10 {\n    color: #ffffff;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .user-management .text-wrapper-11 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 87px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .user-management .text-wrapper-12 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 135px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 3px;\n    white-space: nowrap;\n  }\n  \n  .user-management .button-end {\n    height: 35px;\n    left: 214px;\n    position: absolute;\n    top: 0;\n    width: 37px;\n  }\n  \n  .user-management .text-wrapper-13 {\n    color: #ffffff;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 2px;\n    white-space: nowrap;\n  }\n  \n  .user-management .vector-stroke {\n    height: 6px;\n    left: 13px;\n    position: absolute;\n    top: 19px;\n    width: 10px;\n  }\n  \n  .user-management .button-add-new {\n    height: 40px;\n    left: 1670px;\n    position: absolute;\n    top: 115px;\n    width: 222px;\n  }\n  \n  .user-management .div-wrapper {\n    background-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 220px;\n  }\n  \n  .user-management .text-wrapper-14 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 47px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 8px;\n    white-space: nowrap;\n  }\n  \n  .user-management .overlap-wrapper {\n    height: 40px;\n    left: 1445px;\n    position: absolute;\n    top: 115px;\n    width: 222px;\n  }\n  \n  .user-management .text-wrapper-15 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 56px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 8px;\n    white-space: nowrap;\n  }\n  \n  .user-management .action-search {\n    height: 40px;\n    left: 32px;\n    position: absolute;\n    top: 115px;\n    width: 464px;\n  }\n  \n  .user-management .overlap-2 {\n    background-color: #ffffff;\n    border: 3px solid;\n    border-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 462px;\n  }\n  \n  .user-management .text-wrapper-16 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 5px;\n    white-space: nowrap;\n  }\n  \n  .user-management .union {\n    height: 17px;\n    left: 428px;\n    position: absolute;\n    top: 8px;\n    width: 17px;\n  }\n  \n  .user-management .baris-isi {\n    height: 765px;\n    left: 30px;\n    overflow: hidden;\n    overflow-y: scroll;\n    position: absolute;\n    top: 250px;\n    width: 1857px;\n  }\n  \n  .user-management .overlap-3 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 131px;\n  }\n  \n  .user-management .text-wrapper-17 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 59px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .user-management .overlap-4 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 0;\n    width: 225px;\n  }\n  \n  .user-management .text-wrapper-18 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 63px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .user-management .overlap-5 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 0;\n    width: 324px;\n  }\n  \n  .user-management .text-wrapper-19 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 83px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    width: 158px;\n  }\n  \n  .user-management .overlap-6 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 0;\n    width: 324px;\n  }\n  \n  .user-management .text-wrapper-20 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 107px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .user-management .rectangle-8 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 0;\n    width: 180px;\n  }\n  \n  .user-management .overlap-7 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 0;\n    width: 321px;\n  }\n  \n  .user-management .text-wrapper-21 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 65px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .user-management .overlap-8 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 0;\n    width: 323px;\n  }\n  \n  .user-management .overlap-9 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 55px;\n    width: 131px;\n  }\n  \n  .user-management .overlap-10 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 55px;\n    width: 225px;\n  }\n  \n  .user-management .overlap-11 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 55px;\n    width: 324px;\n  }\n  \n  .user-management .text-wrapper-22 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 85px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 9px;\n    width: 153px;\n  }\n  \n  .user-management .overlap-12 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 55px;\n    width: 324px;\n  }\n  \n  .user-management .text-wrapper-23 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 77px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .user-management .rectangle-9 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 55px;\n    width: 180px;\n  }\n  \n  .user-management .overlap-13 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 55px;\n    width: 321px;\n  }\n  \n  .user-management .text-wrapper-24 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 65px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 9px;\n    white-space: nowrap;\n  }\n  \n  .user-management .overlap-14 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 55px;\n    width: 323px;\n  }\n  \n  .user-management .text-wrapper-25 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 66px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 9px;\n    width: 191px;\n  }\n  \n  .user-management .overlap-15 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 110px;\n    width: 131px;\n  }\n  \n  .user-management .overlap-16 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 110px;\n    width: 225px;\n  }\n  \n  .user-management .overlap-17 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 110px;\n    width: 324px;\n  }\n  \n  .user-management .text-wrapper-26 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 87px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    width: 150px;\n  }\n  \n  .user-management .overlap-18 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 110px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-10 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 110px;\n    width: 180px;\n  }\n  \n  .user-management .overlap-19 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 110px;\n    width: 321px;\n  }\n  \n  .user-management .overlap-20 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 110px;\n    width: 323px;\n  }\n  \n  .user-management .text-wrapper-27 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 81px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    width: 162px;\n  }\n  \n  .user-management .overlap-21 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 165px;\n    width: 131px;\n  }\n  \n  .user-management .overlap-22 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 220px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-11 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 275px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-12 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 330px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-13 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 385px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-14 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 440px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-15 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 495px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-16 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 550px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-17 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 605px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-18 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 660px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-19 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 715px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-20 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 770px;\n    width: 131px;\n  }\n  \n  .user-management .overlap-23 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 165px;\n    width: 225px;\n  }\n  \n  .user-management .overlap-24 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 220px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-21 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 275px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-22 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 330px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-23 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 385px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-24 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 440px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-25 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 495px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-26 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 550px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-27 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 605px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-28 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 660px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-29 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 715px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-30 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 770px;\n    width: 225px;\n  }\n  \n  .user-management .overlap-25 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 165px;\n    width: 324px;\n  }\n  \n  .user-management .text-wrapper-28 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 78px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    width: 167px;\n  }\n  \n  .user-management .overlap-26 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 165px;\n    width: 324px;\n  }\n  \n  .user-management .text-wrapper-29 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 74px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .user-management .overlap-27 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 220px;\n    width: 324px;\n  }\n  \n  .user-management .text-wrapper-30 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 57px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    width: 209px;\n  }\n  \n  .user-management .overlap-28 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 220px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-31 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 275px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-32 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 275px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-33 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 330px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-34 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 330px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-35 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 385px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-36 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 385px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-37 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 440px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-38 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 440px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-39 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 495px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-40 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 495px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-41 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 550px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-42 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 550px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-43 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 605px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-44 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 605px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-45 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 660px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-46 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 660px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-47 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 715px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-48 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 715px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-49 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 770px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-50 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 770px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-51 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 165px;\n    width: 180px;\n  }\n  \n  .user-management .overlap-29 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 165px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-52 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 220px;\n    width: 180px;\n  }\n  \n  .user-management .overlap-30 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 220px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-53 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 275px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-54 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 275px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-55 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 330px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-56 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 330px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-57 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 385px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-58 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 385px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-59 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 440px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-60 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 440px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-61 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 495px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-62 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 495px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-63 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 550px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-64 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 550px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-65 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 605px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-66 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 605px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-67 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 660px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-68 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 660px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-69 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 715px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-70 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 715px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-71 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 770px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-72 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 770px;\n    width: 321px;\n  }\n  \n  .user-management .overlap-31 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 165px;\n    width: 323px;\n  }\n  \n  .user-management .text-wrapper-31 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 86px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    width: 152px;\n  }\n  \n  .user-management .overlap-32 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 220px;\n    width: 323px;\n  }\n  \n  .user-management .text-wrapper-32 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 84px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    width: 156px;\n  }\n  \n  .user-management .rectangle-73 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 275px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-74 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 330px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-75 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 385px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-76 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 440px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-77 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 495px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-78 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 550px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-79 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 605px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-80 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 660px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-81 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 715px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-82 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 770px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-83 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 825px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-84 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 825px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-85 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 825px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-86 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 825px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-87 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 825px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-88 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 825px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-89 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 825px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-90 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 880px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-91 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 935px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-92 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 990px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-93 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1045px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-94 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1100px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-95 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1155px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-96 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1210px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-97 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1265px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-98 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1320px;\n    width: 131px;\n  }\n  \n  .user-management .rectangle-99 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 880px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-100 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 935px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-101 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 990px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-102 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1045px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-103 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1100px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-104 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1155px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-105 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1210px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-106 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1265px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-107 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1320px;\n    width: 225px;\n  }\n  \n  .user-management .rectangle-108 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 880px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-109 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 880px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-110 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 935px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-111 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 935px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-112 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 990px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-113 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 990px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-114 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 1045px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-115 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 1045px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-116 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 1100px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-117 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 1100px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-118 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 1155px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-119 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 1155px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-120 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 1210px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-121 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 1210px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-122 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 1265px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-123 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 1265px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-124 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 695px;\n    position: absolute;\n    top: 1320px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-125 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 366px;\n    position: absolute;\n    top: 1320px;\n    width: 324px;\n  }\n  \n  .user-management .rectangle-126 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 880px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-127 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 880px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-128 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 935px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-129 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 935px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-130 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 990px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-131 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 990px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-132 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1045px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-133 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1045px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-134 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1100px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-135 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1100px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-136 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1155px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-137 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1155px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-138 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1210px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-139 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1210px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-140 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1265px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-141 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1265px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-142 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1320px;\n    width: 180px;\n  }\n  \n  .user-management .rectangle-143 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1320px;\n    width: 321px;\n  }\n  \n  .user-management .rectangle-144 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 880px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-145 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 935px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-146 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 990px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-147 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 1045px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-148 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 1100px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-149 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 1155px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-150 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 1210px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-151 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 1265px;\n    width: 323px;\n  }\n  \n  .user-management .rectangle-152 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1349px;\n    position: absolute;\n    top: 1320px;\n    width: 323px;\n  }\n   */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
